import React, { useContext } from 'react'
import { ContentInner } from '../../../layout/Content'
import POItemInnerStyle from './css/POItemInnerStyle'
import PrinterSettingsStyle from '../../../../css/PrinterSettingsStyle'
import { poItemControllerContext } from './POItemController'

function POItemInner() {
  const poItemController = useContext(poItemControllerContext)
  const { poItem } = poItemController
  return (
    <ContentInner>
      <div className='po-wrapper printable'>
        <div id='po-item-container'>
          <div id='po-header-container'>
            <label>Purchase Order</label>
          </div>
          <div id='po-header-details-container'>
            <div className='fields-group-container' id='group-1-fields-container'>
              <div className='field-group' id='date-time-created-group'>
                <label>Date Time Created</label>
                <p>{new Date(poItem.date_time_created).toLocaleString("en-us", { timeZone: poItem.client_timezonee })} { poItem.client_timezone }</p>
              </div>
              <div className='field-group' id='date-time-created-group'>
                <label>Date Prepared</label>
                <p>{new Date(poItem.date_prepared).toLocaleString("en-us", { timeZone: poItem.client_timezone }).split(',')[0]} { poItem.client_timezone }</p>
              </div>
              <div className='field-group' id='supplier-group'>
                <label>Supplier</label>
                <p>{poItem.supplier}</p>
              </div>
              <div className='field-group' id='prepared_by-group'>
                <label>Prepared By</label>
                <p>{poItem.prepared_by}</p>
              </div>
            </div>
            <div className='fields-group-container' id='group-2-fields-container'>
              <div className='field-group' id='reference_code-group'>
                <label>Reference</label>
                <p>{poItem.reference_code}</p>
              </div>
              <div className='field-group' id='remarks-group'>
                <label>Remarks</label>
                <p>{poItem.remarks}</p>
              </div>
              <div className='field-group' id='status-group'>
                <label>Status</label>
                <p>{poItem.status}</p>
              </div>
            </div>
          </div>
          <table className='item-details-table striped-table'>
            <thead>
              <tr>
                <th>#</th>
                <th>Item</th>
                <th>Unit</th>
                <th style={{textAlign: 'center'}}>Quantity</th>
                <th>Remarks</th>
              </tr>
            </thead>
            {
              poItem.item_details.map((item_detail, index) => (
                <tbody key={index}>
                  <tr>
                    <td>{index+1}</td>
                    <td>{item_detail.name}</td>
                    <td>{item_detail.unit}</td>
                    <td style={{textAlign: 'center'}}>{item_detail.quantity}</td>
                    <td>{item_detail.remarks}</td>
                  </tr>
                </tbody>
              ))
            }
          </table>
        </div>
        <POItemInnerStyle />
        { <PrinterSettingsStyle paperWidth='8.5inch'/> }
      </div>
    </ContentInner>
  )
}

export default React.memo(POItemInner)